import React from 'react';

function Contact() {
  return (
    <div className="contact">
      <h1>Contact Us!</h1>
      <p className='info'>Feel free to reach out our execs via email below if you have any questions/concerns!</p>
      <p className='info'>puzzleclub@case.edu</p>
    </div>
  );
}

export default Contact;